/** Row shape for Imported Leave admin list (matches API `LeaveBalanceDto`). */
export interface ImportedLeaveBalance {
  id: string;
  userId: string;
  employeeName: string;
  employeeNumber?: number | null;
  departmentName?: string | null;
  leaveTypeName: string;
  leaveTypeDisplayName: string;
  periodYear: number;
  month?: number | null;
  monthLabel?: string | null;
  daysTaken: number;
  updatedAtUtc: string;
}

/** API DTO — tolerate PascalCase until axios normalises. */
export type ImportedLeaveBalanceApi = ImportedLeaveBalance & {
  Id?: string;
  UserId?: string;
};

export function isValidGuid(value: string): boolean {
  if (!value || value === '00000000-0000-0000-0000-000000000000') {
    return false;
  }
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
}

export function mapImportedLeaveBalance(item: ImportedLeaveBalanceApi): ImportedLeaveBalance | null {
  const id = item.id ?? item.Id;
  if (!id || !isValidGuid(String(id))) {
    return null;
  }
  return {
    id: String(id),
    userId: String(item.userId ?? item.UserId ?? ''),
    employeeName: item.employeeName,
    employeeNumber: item.employeeNumber,
    departmentName: item.departmentName,
    leaveTypeName: item.leaveTypeName,
    leaveTypeDisplayName: item.leaveTypeDisplayName,
    periodYear: item.periodYear,
    month: item.month,
    monthLabel: item.monthLabel,
    daysTaken: item.daysTaken,
    updatedAtUtc: item.updatedAtUtc,
  };
}

export function balanceRowKey(row: ImportedLeaveBalance): string {
  return `${row.id}-${row.userId}-${row.leaveTypeName}-${row.periodYear}-${row.month ?? 'y'}`;
}
